export enum OrgTreeSortType {
  Default = 'Default',
  ManagementGroup = 'ManagementGroup',
  MercerJobCode = 'MercerJobCode',
  MercerPositionClass = 'MercerPositionClass'
}
